import { z } from 'zod';

import { responsiveSchema } from '../../utils';

/**
 * A colour, as one string: a theme preset name (`primary`, `light`, …) or a
 * literal CSS colour (`#fff`, `rgba(…)`). The host's `colorCss` resolver tells
 * the two apart — a preset follows the theme, a literal is used as-is — which is
 * why the name travels as the value rather than beside it.
 */
export const colorValueSchema = z.string().nullable();

export const responsiveColorValueSchema = responsiveSchema(colorValueSchema);

export type ColorValue = z.output<typeof colorValueSchema>;

/**
 * A colour stored before it became one string, as the `{ value, presetName }`
 * pair. The preset wins: it is the later, more specific write, and reading
 * `value` alone would freeze a themed colour on whatever hex it happened to hold.
 */
export const colorFromValueAndPreset = (
    color: { value?: string | null; presetName?: string | null } | null | undefined
): ColorValue => color?.presetName ?? color?.value ?? null;
